var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartData['days'])?_c('vChart',{ref:"chart",staticClass:"cts-bar-chart",attrs:{"options":_vm.option,"autoresize":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }